import type { ReactElement } from "react";
import { SrIcon } from "./SrIcon.tsx";

interface Props {
  stale: boolean;
  minutesLeft: number;
  repairedAt: string;
  onRerun: () => void;
}

export function ValidityStrip({ stale, minutesLeft, repairedAt, onRerun }: Props): ReactElement {
  const m = minutesLeft;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  const ttl = h > 0 ? `${h}h ${rem}m` : `${rem}m`;
  return (
    <div className={`sr-validity ${stale ? "sr-stale" : ""}`}>
      <span className="sr-v-pulse" />
      {stale ? (
        <>
          <span>
            <span className="sr-v-strong">Repair is 2 hours stale.</span> Odds may have moved on the books since this
            was generated.
          </span>
          <button className="sr-v-rerun" onClick={onRerun}>
            <SrIcon name="refresh" size={11} />
            Re-run repair
          </button>
        </>
      ) : (
        <>
          <span>
            Repaired at <span className="sr-v-strong">{repairedAt}</span> · valid for the next{" "}
            <span className="sr-v-strong">{ttl}</span> · odds subject to movement.
          </span>
          <span className="sr-v-ttl">VALID · {ttl} REMAINING</span>
          <button className="sr-v-rerun" onClick={onRerun}>
            <SrIcon name="refresh" size={11} />
            Re-run
          </button>
        </>
      )}
    </div>
  );
}
